import { type InfiniteData } from '@tanstack/react-query';
import produce from 'immer';

import { type ListNotificationsResponse } from '@air/api/types';

export const markNotificationAsReadInCache = (
  data: InfiniteData<ListNotificationsResponse> | undefined,
  notificationId: string,
) => {
  const date = new Date().toISOString();

  if (!data) return;

  return produce(data, (draft) => {
    draft.pages.forEach((page) => {
      page.items.forEach((item) => {
        if (item.id === notificationId && !item.readAt) {
          item.readAt = date;
        }
      });
    });
  });
};
